import img from "../assets/images/shutterstock_699442570-min.jpg";
import { useState, useRef } from "react";
import constants from "../constants/constants";
import SEO from "./seo.component";
import pageSEO from "../constants/pageSEO";

export default function Reports() {
  const [popup, setPopup] = useState(false);
  const formRef = useRef(null);

  async function submitForm(event) {
    event.preventDefault();

    if (!formRef.current) return;

    const formData = new FormData(formRef.current);
    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: json,
      });

      const data = await res.json();

      if (data?.success) {
        setPopup({
          subject: "Thanks for your message!",
          message: "We will get back to you as soon as possible",
        });
      } else {
        setPopup({
          subject: "We encountered an error in sending this message",
          message: "Please try again later",
        });
      }
    } catch (err) {
      console.error(err);
      setPopup({
        subject: "We encountered an error in sending this message",
        message: "Please try again later",
      });
    }
  }

  const seoConfig = pageSEO.reports();
  return (
    <>
      <SEO {...seoConfig} />
      <div className="max-w-[1100px] pt-[100px] mx-auto grid md:grid-cols-2 px-6 gap-x-24 gap-y-10 min-h-[70vh] mb-12">
        <div>
          <h1 className="text-4xl text-black font-mont ">
            FREE REAL ESTATE REPORTS
          </h1>

          <p className="font-semibold text-med-grey my-5">
            Get exclusive buyer & seller real estate reports to help you with
            your next purchase or sale. Get insider tips and tricks, and learn
            how to invest your time and money wisely in the real estate market.
            Just complete the form below, select all the reports you'd like to
            receive and have them emailed to your inbox right away. Get started
            now!
          </p>
          <form ref={formRef} onSubmit={submitForm}>
            <input
              type="hidden"
              name="access_key"
              value={constants.EMAIL_ACCESS_KEY}
            />
            <input
              type="hidden"
              name="subject"
              value="New Lead Interested in Real Estate Reports"
            />

            <div className="form-item">
              <label className="form-label">Name*</label>
              <input
                required
                className="form-input"
                name="Name"
                placeholder="Full Name"
              ></input>
            </div>
            <div className="form-item">
              <label className="form-label">Email*</label>
              <input
                required
                className="form-input"
                name="Email Address"
                placeholder="Email Address"
              ></input>
            </div>
            <div className="form-item">
              <label className="form-label">I am a*</label>
              <select required className="form-input" name="Client Type">
                <option value={""}>Please Select</option>
                <option value={"Buyer"}>Buyer</option>
                <option value={"Seller"}>Seller</option>
                <option value={"Renter"}>Renter</option>
                <option value={"Other"}>Other</option>
              </select>
            </div>
            <div className="form-item">
              <label className="form-label">I am interested in:</label>
              <div className="grid grid-cols-2 gap-3 mt-3">
                <div className="cursor-pointer">
                  <input
                    className="mr-2"
                    name="Interested in:"
                    value={"Buying guides"}
                    type="checkbox"
                    id="1"
                  />
                  <label htmlFor="1">Guides for Buying</label>
                </div>
                <div>
                  <input
                    className="mr-2"
                    name="Interested in:"
                    value={"Selling guides"}
                    type="checkbox"
                    id="2"
                  />
                  <label htmlFor="2">Guides for Selling</label>
                </div>
                <div>
                  <input
                    className="mr-2"
                    name="Interested in:"
                    value={"Choosing realtor"}
                    type="checkbox"
                    id="3"
                  />
                  <label htmlFor="3">Choosing a Realtor</label>
                </div>
                <div>
                  <input
                    className="mr-2"
                    name="Interested in:"
                    value={"Renovations"}
                    type="checkbox"
                    id="4"
                  />
                  <label htmlFor="4">Home Renovations</label>
                </div>
              </div>
            </div>
            <button
              type="submit"
              className="btn-rounded rounded-none self-start px-10 mt-3"
            >
              Submit
            </button>
          </form>
        </div>
        <div className="overflow-hidden h-[600px] ">
          <img className="h-full w-full object-cover" src={img} />
        </div>
      </div>
      {popup && (
        <>
          <div className="backdrop" />
          <div className="popup">
            <h5 className="font-bold text-black text-lg">{popup.subject}</h5>
            <p className="font-semibold text-med-grey tracking-wide mb-3">
              {popup.message}
            </p>
            <button onClick={() => setPopup(false)} className="btn-rounded">
              Close
            </button>
          </div>
        </>
      )}
    </>
  );
}
